import { call, put, takeLatest } from "@redux-saga/core/effects";
import { FeedbackConstant } from "./FeedbackConstant";
import { FeedbackApi } from "./FeedbackApi";
import { FeedbackParser } from "./FeedbackParser";


function* getFeedbackData({ payload }) {
  let {status,from_date,to_date, search_term, page, limit}= payload
  
  try {
    yield put({ type: FeedbackConstant.FEEDBACK_REQUEST });
    const res = yield call(FeedbackApi.getFeedbackData, {
      status,
      to_date,
      from_date,
      search_term,
      page,
      limit,
      
    });
    const payload = FeedbackParser.getFeedbackParser(res)
    yield put({
      type: FeedbackConstant.FEEDBACK_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: FeedbackConstant.FEEDBACK_RESPONSE,
      payload: [],
    });
  }
}


export function* FeedbackDataSaga() {
  yield takeLatest(FeedbackConstant.FEEDBACK_SAGA, getFeedbackData);
}
